import { MjmlButton, MjmlColumn, MjmlSection } from "@faire/mjml-react";
import type { FC } from "react";
import { Fragment } from "react";
import { makePollUrl } from "../../../make-poll-url";
import type { PollButtonProps } from "../types";

export const VerticalPollButtons: FC<PollButtonProps> = ({
  buttonType,
  options,
  account_id,
  align,
  buttonWidth,
}) => {
  return (
    <Fragment>
      <MjmlSection mjmlClass="section">
        <MjmlColumn>
          {options.map((option) => (
            <MjmlButton
              key={option.id}
              mjmlClass={buttonType}
              href={makePollUrl(account_id, option.id)}
              align={align}
              width={`${buttonWidth}px`}
            >
              {option.text}
            </MjmlButton>
          ))}
        </MjmlColumn>
      </MjmlSection>
    </Fragment>
  );
};
